import moment from "moment";
import { Constant } from "../constant/constant";
import i18n from "../language/i18n";
import { ACCOUNT } from "../services/services-model.type";

export const getAccountStatus = (status?: string) => {
  if (status === "A") {
    return i18n.t("ACC_HOAT_DONG");
  } else if (status === "P") {
    return i18n.t("ACC_CAM_CO");
  } else if (status === "M") {
    return i18n.t("ACC_DEN_HAN");
  } else if (status === "C") {
    return i18n.t("COMMON_DONG");
  }
  return i18n.t("ACC_KHONG_HOAT_DONG");
};

export const mapAccountPayments = (data: ACCOUNT[]) => {
  let payments: ACCOUNT[] = [];
  let other: ACCOUNT[] = [];
  data.forEach((item) => {
    if (item.ACCOUNTTYPE === Constant.ACCOUNTTYPE.ACCOUNT_PAYMENT && item.PRODUCTCODE === Constant.PRODUCT_CODE_PAYMENT) {
      payments.push(item);
    } else {
      other.push(item);
    }
    return item;
  });
  return payments.concat(other);
};

export const CompareDateToDate = (fromDate?: string, toDate?: string) => {
  if (fromDate && toDate) {
    let startDate = moment(fromDate, "DD/MM/YYYY").valueOf();
    let endDate = moment(toDate, "DD/MM/YYYY").valueOf();
    if (startDate <= endDate) {
      return true;
    } else return false;
  }
  return true;
};

export const CompareDateToDateDistance = (numberDate: number = 0, fromDate?: string, toDate?: string) => {
  if (fromDate && toDate) {
    let startDate = moment(fromDate, "DD/MM/YYYY").valueOf();
    let endDate = moment(toDate, "DD/MM/YYYY").valueOf();
    let compareDate = (endDate - startDate) / (24 * 60 * 60 * 1000);
    if (compareDate <= numberDate) {
      return true;
    } else return false;
  }
  return true;
};

export const formatDate = (value?: string, format?: string) => {
  if (value?.length) {
    return moment(value, format ? format : "DD/MM/YYYY hh:mm:ss").format("DD/MM/YYYY");
  }
  return value;
};

export const formatDateTime = (value?: string, formatStart?: string, formatEnd?: string) => {
  if (value?.length) {
    return moment(value, formatStart ? formatStart : "DD/MM/YYYY hh:mm:ss").format(formatEnd ? formatEnd : "DD/MM/YYYY");
  }
  return value;
};
